export default __webpack_public_path__ + "static/media/github-original.2a539281.svg";